import { useState } from 'react'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import { ProductTileProduct } from '@moonpig/web-shared-products'
import { LoadMoreType, PageLoadState } from '../types'
import { loadMoreGAEventDetails } from '../../analytics/GAEvents'

export const useLoadPage = ({
  loadMoreProducts,
  products,
}: {
  loadMoreProducts: (isPrevious: boolean) => Promise<boolean>
  products: ProductTileProduct[]
}) => {
  const [loaded, setLoaded] = useState(true)
  const [loadState, setLoadState] = useState(PageLoadState.Loaded)

  const loadMoreProductsCallback = async (loadMoreType: LoadMoreType) => {
    const isPrevious =
      loadMoreType === LoadMoreType.SCROLL_PREV ||
      loadMoreType === LoadMoreType.CLICK_PREV

    if (loadMoreType === LoadMoreType.CLICK) {
      trackGAEvent(loadMoreGAEventDetails(products.length))
    }
    const result = await loadMoreProducts(isPrevious)

    return result
  }

  const loadPage = async (
    loadMoreType: LoadMoreType,
  ): Promise<PageLoadState> => {
    try {
      if (await loadMoreProductsCallback(loadMoreType)) {
        return PageLoadState.Loaded
      }
      return loadMoreType === LoadMoreType.CLICK ||
        loadMoreType === LoadMoreType.SCROLL
        ? PageLoadState.LoadingNext
        : PageLoadState.LoadingPrev
    } catch (e) {
      /* istanbul ignore next */
      return PageLoadState.Error
    }
  }

  const loadCallback = async (loadMoreType: LoadMoreType) => {
    setLoaded(false)
    const isPreviousPage =
      loadMoreType === LoadMoreType.SCROLL_PREV ||
      loadMoreType === LoadMoreType.CLICK_PREV

    setLoadState(
      isPreviousPage ? PageLoadState.LoadingPrev : PageLoadState.LoadingNext,
    )
    const loadPageState = await loadPage(loadMoreType)
    setLoadState(loadPageState)
    setLoaded(true)
    return loadPageState
  }

  return { loadCallback, loadState, loaded }
}
